import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountCodeSegment  {
    _originalTypeClassName = "zERP.BO.AccountCodeSegment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountCodeSegment.translate = translateService;
}
this.Id = null;
this.Length = null;
this.Seperator = null;
this.AllowLetters = false;
this.AllowDigits = true;
this.Optional = false;
this.AllowSymbols = false;
this.Preview = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Length:any;
Seperator:any;
AllowLetters:any;
AllowDigits:any;
Optional:any;
AllowSymbols:any;
Preview:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}